/*
PM 2021-07-29
KONCEPCJA KOMPONENTU
================

Komponent mapy

================

Kontener mapy to komponent MapContainer (zaimportowany z biblioteki react-leaflet)
Propsy komponentu MapContainer:
* center - wspolrzedne srodka mapy, tylko do inicjacji, brane z propsa obszar (od komponentu rodzica MapContainer)

Wybor warstwy (stylu) mapy to komponent LayersControl (zaimportowany z biblioteki react-leaflet)
Warstwy do wyboru to komponenty LayersControl.BaseLayer
Props checked mowi, ktora warstwa jest wyswietlana domyslnie
Warstwy sa renderowane przez komponenty TileLayer (zaimportowany z biblioteki react-leaflet)
Mozna je nakladac na siebie

Na mapie sa renderowane obiekty noclegowe jako pineski - komponenty Marker (zaimportowany z biblioteki react-leaflet)
Komponent Tooltip to dymek pojawiajacy sie po najechaniu na pineske (zaimportowany z biblioteki react-leaflet)
Style markerow brane z propsa - funkcji getIcon (od komponentu rodzica MapContainer)

================
importowane komponenty:

*/

import * as React from 'react';

import {
    MapContainer, TileLayer, Marker, Tooltip, LayersControl,
    ZoomControl, ScaleControl, Circle, Pane, Polygon, Polyline, useMap, Popup, useMapEvents, CircleMarker, SVGOverlay
} from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

import L, { TileErrorEvent, LayersControlEvent, LeafletMouseEvent } from 'leaflet';

import { connect } from 'react-redux';

import { AppState, IPageState, store, Actions } from '../../appredux';
import { tiles } from '../map_new/mapData';
import { Info, MapaOpis, RegionCell } from '../../api';

import Routing from "../map_new/Routing";
import Search from "../map_new/Search";
import './Map.css';
import { Fab } from '@material-ui/core';
import { MuiThemeProvider} from '@material-ui/core/styles';
import theme from 'themes';

import 'leaflet-geosearch/dist/geosearch.css';
import * as M from '@material-ui/core';
import CONFIG from 'cfg/config';

import {Poland, Poland1, Poland2, krakow, Poland5} from "./Poland"
import { PROCENT_PASKA_X_1, opisy } from './mapDataOpisy';

export const ThemeOrange = M.createTheme({
    palette: {
      primary: {
        main: "#e65100",
      },
      secondary: {
        main: "#3a87ad",
      },
    },
  });


//PM 2021-11-30
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface MapProps {
    page: IPageState,

    getIcon: (color: number) => L.Icon | undefined, //pobieranie koloru pineski                            
    tileErrors: string[],
    tileName: string,
    addTileError: (aName: string) => Promise<void>,
    setTileName: (aName: string) => Promise<void>,
}

interface MapState {
    //isMapInit: boolean,
    mode: number,   // 0 - odległość, 1 - trasa
    //refresh: number

    //clickLat: number,
    //clickLng: number

}
const GEOCODE_URL = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&langCode=PL&location=";

class Map extends React.Component<MapProps, MapState>  {
    mapRef: any; //React.RefObject<L.Map>; useRef(null)


    constructor(props: MapProps) {
        super(props, {});
        this.mapRef = React.createRef() //as React.RefObject<L.Map>
        //this.mapRef = React.useRef(null) //as React.RefObject<L.Map>
        this.state = {
            //isMapInit: false,
            mode: 0,
            
            //refresh: 0
            //clickLat: 0,
            //clickLng: 0
        }

    //     setInterval(() => {
    //         let input1 = document.getElementsByClassName("glass")
    //   console.log(input1)
    //   if(input1.length >0 ){
    //     input1[0].setAttribute("value", "Rzeszów, ")
    //   }
    //     }, 300);
    }

    componentDidMount(): void {
        
    }

   

    //PM 2021-10-19
    baseLayerChange = async (event: LayersControlEvent) => {
        await this.props.setTileName(event.name)
    }

    //raz przy tworzeniu mapy
    //PM 2021-10-19
    whenCreated = (map: any) => {
        //console.log(map)
        map.target.on('baselayerchange', this.baseLayerChange);
        this.mapRef.current = map

        //this.setState({
        //    isMapInit: true
        //  });
    }



    //PM 2021-04-21
    dajFont = (opis: MapaOpis) => {
        if (window.innerWidth < 600)
            return opis.mapaOpisFontSizeMobile;
        else if (window.innerWidth <= 1366)
            return opis.mapaOpisFontSize1280;
        else if (window.innerWidth <= 1600)
            return opis.mapaOpisFontSize1600;
        else
            return opis.mapaOpisFontSize1920;
    }

    //SW 2021-04-19 //PM 2021-04-21 
    opis = (o: MapaOpis) => {
        //const SVGOverlayTextStyle: React.CSSProperties = { fontSize: this.dajFont(o) + 'px' };
        const SVGOverlayTextStyle: React.CSSProperties = { fontSize:  '12px' };
        const stroke = 'white';
        const strokeWidth = window.innerWidth < 600 ? 0 : 4;
        let wysokoscPaska = Number(o.mapaOpisWspGoraSzerokosc) - Number(o.mapaOpisWspDolSzerokosc);
        const szerokoscPaska = Number(o.mapaOpisWspPrawaDlugosc) - Number(o.mapaOpisWspLewaDlugosc);
        const przedluzeniePaska = window.innerWidth < 600 ? szerokoscPaska : 0;
        const odstep = window.innerWidth < 600 ? '1px' : '10px';
        let cellsOpis: RegionCell[] = [];
        let cellDescription: RegionCell | undefined = new RegionCell();

        if (window.innerWidth < 600)
            wysokoscPaska = wysokoscPaska * 1.25;

        if (o.obszarId === '0') {
            cellsOpis = [new RegionCell()]
            cellDescription = new RegionCell();
            //cellsOpis = this.props.cells.filter(c => c.krainaId === Number(o.krainaId));
            //cellDescription = this.props.cellsDescription.find(c => c.krainaId === Number(o.krainaId));
        }
        else {
            cellsOpis = [new RegionCell()]
            cellDescription = new RegionCell();
            //cellsOpis = this.props.cells.filter(c => c.obszarId === Number(o.obszarId));
            //cellDescription = this.props.cellsDescription.find(c => c.obszarId === Number(o.obszarId));
        }
        //vscTest
        //console.log(cellsOpis)
        if (cellDescription && cellsOpis.length)
            return (
                // <SVGOverlay
                //     key={o.id}
                //     bounds={[
                //         [Number(o.mapaOpisWspGoraSzerokosc), Number(o.mapaOpisWspLewaDlugosc)],
                //         [Number(o.mapaOpisWspGoraSzerokosc/* - 0.02624*/) - this.state.wskazowkiPionowyOffset, Number(o.mapaOpisWspLewaDlugosc) + getSzerokoscPaskaDuzaCzcionka(o.opis) * this.state.wskazowkiPoziomyOffset],
                //     ]}
                // >
                //     <rect x="0" y="0" width="100%" height="100%" fill="orange" />
                //     <text
                //         x="5px" y="75%" style={SVGOverlayTextStyle} fill={SVGOverlayTextFill}
                //     >
                //         {o.opis}
                //     </text>
                // </SVGOverlay>
                <React.Fragment>
                    <SVGOverlay
                        key={o.id}
                        bounds={[
                            [Number(o.mapaOpisWspGoraSzerokosc), Number(o.mapaOpisWspLewaDlugosc)],
                            [Number(o.mapaOpisWspGoraSzerokosc) - wysokoscPaska, Number(o.mapaOpisWspPrawaDlugosc) + przedluzeniePaska],
                        ]}
                    >
                        <rect
                            x="0" y="0" width="100%" height="100%"
                            fill={o.mapaOpisTloKolor} stroke={stroke} strokeWidth={strokeWidth}
                            //onClick={async () => await this.props.onOpisClick(o)}
                        />
                        <text
                            x={odstep} y="75%" style={SVGOverlayTextStyle} fill={o.mapaOpisFontKolor} //onClick={async () => await this.props.onOpisClick(o)}
                        >
                            {o.opis}
                        </text>
                    </SVGOverlay>
                    <SVGOverlay
                        key={o.id + ' * noclegow'}
                        bounds={[
                            [(Number(o.mapaOpisWspGoraSzerokosc) - wysokoscPaska) - (PROCENT_PASKA_X_1 * wysokoscPaska), Number(o.mapaOpisWspLewaDlugosc)],
                            [(Number(o.mapaOpisWspGoraSzerokosc) - wysokoscPaska) - ((1 + PROCENT_PASKA_X_1) * wysokoscPaska), Number(o.mapaOpisWspPrawaDlugosc) + przedluzeniePaska],
                        ]}
                    >
                        <rect
                            x="0" y="0" width="100%" height="100%"
                            fill={o.mapaOpisTloKolor} stroke={stroke} strokeWidth={strokeWidth}
                            //onClick={async () => await this.props.onOpisClick(o)}
                        />
                        <text
                            x={odstep} y="75%" style={SVGOverlayTextStyle} fill={o.mapaOpisFontKolor} //onClick={async () => await this.props.onOpisClick(o)}
                        >
                            {'pasiek '  + cellDescription.iloscW} {/* min */}
                        </text>
                    </SVGOverlay>
                    <SVGOverlay
                        key={o.id + ' * wiecej'}
                        bounds={[
                            [(Number(o.mapaOpisWspGoraSzerokosc) - wysokoscPaska) - ((1 + 2 * PROCENT_PASKA_X_1) * wysokoscPaska), Number(o.mapaOpisWspLewaDlugosc)],
                            [(Number(o.mapaOpisWspGoraSzerokosc) - wysokoscPaska) - ((2 + 2 * PROCENT_PASKA_X_1) * wysokoscPaska), Number(o.mapaOpisWspPrawaDlugosc) + przedluzeniePaska],
                        ]}
                    >
                        <rect
                            x="0" y="0" width="100%" height="100%"
                            fill={o.mapaOpisTloKolor} stroke={stroke} strokeWidth={strokeWidth}
                            //onClick={async () => await this.props.onOpisClick(o)}
                        />
                        <text
                            x={odstep} y="75%" style={SVGOverlayTextStyle} fill={o.mapaOpisFontKolor} //onClick={async () => await this.props.onOpisClick(o)}
                        >
                            {'zobacz więcej ...'}
                        </text>
                    </SVGOverlay>
                </React.Fragment>
            );
    }




    //główna pętla
    //PM 2021-11-30
    //obsługa braku wspolrzednych do mapy
    render = () => {

        let latNumber = 51.94725;
        let lngNumber = 19.28035;
        const promien = 3.6; 
                     
        const bounds: L.LatLngBoundsExpression = [         //początkowe granice mapy
                    [latNumber + promien, lngNumber - promien],
                    [latNumber - promien, lngNumber + promien],
                ]


        let opisyMapy : MapaOpis[] = opisy  //.slice(0,4)                 

        //let abc : any = []                  
        //let qwe = Poland5.flat()  
        //qwe.forEach( x => {   
        //    //abc.push(x.slice(5,15))
        //    x.length >= 5 ? abc.push(x) : null
        //} )                

        //let mapa = krakow.flat().flat()                 
        let mapa = krakow.flat().flat()    
        //let mapa = abc.flat()   


         console.log(Poland5)                  
         console.log(Poland5.flat())                  
         console.log(mapa)                  
        // console.log(pol[1])                  
        // console.log(Poland3.flat().flat().flat())                  
        // console.log(Poland3.flat().flat())                  
        // console.log(Poland3)                  
        // console.log(Poland3[0])                  
        // console.log(Poland3[0].flat())                  
        // console.log(Poland3[0].flat().flat())                  
        // console.log(Poland3[0].flat().flat()[0])                  
        // console.log(Poland3[0].flat().flat()[1])                  

                          //console.log(this.state)

        //let clickedMap = this.state.clickLat !== 0 && this.state.clickLng !== 0                  
                          
                                     
// maxHeight: window.innerWidth > 600 ? '' : window.innerWidth + 'px'
        return (
            <>
            <MapContainer 
                bounds={bounds}
                zoomSnap={0.1} zoomDelta={0.5} 
                //style={{ height: (window.innerHeight - 200) + 'px', }}
                style={{ height: (window.innerHeight - 12 ) + 'px', }}

                zoomControl={false}

                // doubleClickZoom={false}
                // closePopupOnClick={false}
                // dragging={false}
                // trackResize={false}
                // touchZoom={false}
                // scrollWheelZoom={false}

                //whenCreated={this.whenCreated}
                //whenCreated={(map: any) => {
                //    console.log("The underlying leaflet map instance:", map)
                //  }}
                // @ts-ignore
                whenReady={ (mapInstance: any) => { this.whenCreated(mapInstance) }} //this.mapRef.current =mapInstance
                // ref={m => {
                //     this.leafletMap = m;
                //   }}

                
            >
                {/* <SetViev refresh={this.state.refresh} lat={this.props.lat} lng={this.props.lng}/> */}

                <TileLayer 
                    attribution={tiles[0].attribution}
                    url={tiles[0].url}
                    eventHandlers={{
                        tileerror: async (event: TileErrorEvent) => {
                            if (!this.props.tileErrors.includes(tiles[0].name))
                                await this.props.addTileError(tiles[0].name)
                        }
                    }}
                />
                {/* <LayersControl >
                    {tiles.filter(tile => !this.props.tileErrors.includes(tile.name)).map((tile, index) => {
                        return (
                            <LayersControl.BaseLayer key={tile.name} checked={this.props.tileErrors.length && index === 0 ? true : tile.checked} name={tile.name}>
                                
                                <TileLayer
                                    attribution={tile.attribution}
                                    url={tile.url}
                                    eventHandlers={{
                                        tileerror: async (event: TileErrorEvent) => {
                                            if (!this.props.tileErrors.includes(tile.name))
                                                await this.props.addTileError(tile.name)
                                        }
                                    }}
                                />
                               
                            </LayersControl.BaseLayer>
                        )
                    })} */}
                    {/* <LayersControl.BaseLayer name="Voyager Znaczniki">
                        <LayerGroup>
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png"
                            />
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}.png"
                            />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Dark Znaczniki">
                        <LayerGroup>
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png"
                            />
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/light_only_labels/{z}/{x}/{y}.png"
                            />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Voyager bez znaczników">
                        <TileLayer
                            attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Dark bez znaczników">
                        <TileLayer
                            attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer> */}
                {/* </LayersControl> */}





                <ZoomControl position="topright" />
                <ScaleControl position="bottomleft" />

               
                

               

               

                    {opisyMapy.map(o => {
                        return (
                            <React.Fragment key={o.id}>
                                <CircleMarker
                                    center={[Number(o.mapaOpisLiniaStopWspSzerokosc), Number(o.mapaOpisLiniaStopWspDlugosc)]}
                                    radius={Number(this.dajFont(o))}
                                    color="whitesmoke"//"whitesmoke"
                                    fillColor="whitesmoke" fillOpacity={0.5} /*"whitesmoke"*/
                                    eventHandlers={{
                                        click: async () => {
                                            //await this.props.onOpisClick(o)
                                        }
                                    }}
                                />
                                {/* <Polyline pathOptions={{ color: o.mapaOpisTloKolor }} positions={multiPolyline} /> */}
                                <Polyline
                                    pathOptions={{ color: "#C4C2C2" }} /*"whitesmoke"*/
                                    positions={[
                                        [Number(o.mapaOpisLiniaStartWspSzerokosc), Number(o.mapaOpisLiniaStartWspDlugosc)],
                                        [Number(o.mapaOpisLiniaStopWspSzerokosc), Number(o.mapaOpisLiniaStopWspDlugosc)]
                                    ]}
                                    eventHandlers={{
                                        click: async () => {
                                            //await this.props.onOpisClick(o)
                                        }
                                    }}
                                />
                                {this.opis(o)}
                            </React.Fragment>
                        )
                    })}

               
            </MapContainer>
            
                 </>
        );
    }
}

// const styles = (theme: Theme) => ({
//     frame: {
//         whiteSpace: 'nowrap' as 'nowrap', /* This is required unless you put the helper span closely near the img */
//         textAlign: 'center' as 'center',
//     },
//     helper: {
//         display: 'inline-block',
//         height: '100%',
//         verticalAlign: 'middle'
//     },
//     img: {
//         verticalAlign: 'middle',
//         maxHeight: '447px',
//         maxWidth: '1000px'
//     }
// });

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(Map);

